module.exports = __webpack_public_path__ + "static/media/desktop.6b2df55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/article-redesign/desktop.png
// module id = 80
// module chunks = 0